import { setContext } from '@apollo/client/link/context';
import { ILogger } from '@bloomays-lib/types.shared';
import { isAuth0TokenRefreshError } from '../../services/authService';
import { Auth0TokenExpiredError } from '../../services/authService';

export const createAuthLink = (getToken: () => Promise<string | undefined>, logger: ILogger) => {
  return setContext(async (_, { headers, isPublic }) => {
    const baseHeaders = {
      ...headers,
      'Apollo-Require-Preflight': 'true',
    };
    try {
      const token = await getToken();
      return {
        headers: {
          ...baseHeaders,
          authorization: token ? `Bearer ${token}` : '',
        },
      };
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      // can failed silently on public routes
      if (isPublic === true) {
        return {
          headers: baseHeaders,
        };
      }
      if (isAuth0TokenRefreshError(error)) {
        logger.warn('Failed to get access token silently', error);

        // Throw a specific error that will be caught at the Apollo Provider level
        throw new Auth0TokenExpiredError('Auth0 token refresh failed', error);
      }
      // For other errors, still throw to maintain existing behavior
      throw error;
    }
  });
};
